import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import Chart from 'chart.js';
import axios from "axios";
var AiChart = /** @class */ (function (_super) {
    tslib_1.__extends(AiChart, _super);
    function AiChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AiChart.prototype.mounted = function () {
        this.drawChart();
        this.$watch("params", this.drawChart);
    };
    AiChart.prototype.drawChart = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, chartData, options;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get(this.chart.url, { params: this.params })];
                    case 1:
                        data = (_a.sent()).data;
                        chartData = data;
                        options = this.chart.options;
                        if (this.chart.url == "devicesensorlog/weektemperature") {
                            new Chart(this.$refs.canvas, {
                                type: this.chart.type,
                                data: {
                                    labels: chartData.map(function (d) { return d.label; }),
                                    datasets: [{
                                            label: "Max",
                                            backgroundColor: "#B94F74",
                                            data: chartData.map(function (d) { return d.max; })
                                        }, {
                                            label: "Min",
                                            backgroundColor: "#3e95cd",
                                            data: chartData.map(function (d) { return d.min; })
                                        }]
                                },
                                options: options
                            });
                        }
                        else {
                            new Chart(this.$refs.canvas, {
                                type: this.chart.type,
                                data: {
                                    labels: data.map(function (d) { return d.label; }),
                                    datasets: [{
                                            label: this.chart.title,
                                            backgroundColor: "#3e95cd",
                                            borderColor: "#455890",
                                            data: chartData.map(function (d) { return d.value; })
                                        }]
                                },
                                options: options
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], AiChart.prototype, "chart", void 0);
    tslib_1.__decorate([
        Prop(),
        tslib_1.__metadata("design:type", Object)
    ], AiChart.prototype, "params", void 0);
    AiChart = tslib_1.__decorate([
        Component
    ], AiChart);
    return AiChart;
}(Vue));
export default AiChart;
